import React from 'react';
import Helmet from 'react-helmet';

import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';

import Confirmation from '../components/modals/common/Confirmation';

import { SpotWorkerTab } from '../components/spotWorker/tab/SpotWorkerTab';
import { SpotWorkerInfo } from '../components/spotWorker/page/SpotWorkerInfo';
import { SpotWorkerImage } from '../components/spotWorker/page/SpotWorkerImage';

import masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';
import { extractErrorMessage } from '../utilities/commonUtil';
import {
  isNullOrUndefinedOrEmptyStr,
  safariOnIosCheck,
} from '../utilities/stringUtil';
import {
  WORKER_TAB,
  WORKER_PAGE_STATUS,
  DIALOG_STATUS,
  SPOT_WORKER_RESIDENCE_TYPE,
  SPOT_WORKER_TAB,
  SPOT_WORKER_TYPE,
} from '../utilities/constants';
import _urlParamManager from '../utilities/urlParamManager';

import styles from '../styles/componentStyle/workerForm/workerForm.scss';
import '../styles/componentStyle/worker/page.css';
import { MasterPageHeader } from '../components/PageHeader';
import SpotWorkersApi from '../services/spotWorkers/SpotWorkersApi';
import SpotWorkersService from '../services/spotWorkers/SpotWorkersService';

/**
 * @props {object} pageStatus ページ情報 (新規・詳細・編集)
 * @props {string} selectedTabId 表示中のタブID
 */
export class SpotWorkerForm extends React.Component {
  constructor(props) {
    super(props);

    this.isClosing = false;

    this.state = {
      // ログイン中ユーザーの権限
      roleId: LocalStorageService.getRoleId(),
      fieldId: SessionStorageService.getFieldId(),

      spotWorkerInfo: {
        name_sei: '',
        name_mei: '',
        name_sei_kana: '',
        name_mei_kana: '',
        worker_type: 2,

        worker_image_register_status: 0,
        worker_image_exclusion_reason: '',
        worker_image_info: {
          allCcusSyncedStatuses: [],
          ccusSyncedStatus: 0,
          allErrors: [],
          hasError: false,
        },
      },
      fetchingInfo: false,

      informationModal: {
        // インフォメーションモーダル用プロパティ (ボタン1つ)
        title: null, // モーダルダイアログのタイトル
        message: null, // モーダルダイアログのメッセージ
        buttonText: null, // モーダルダイアログのボタンのタイトル
      },
      selectedTabId: props.selectedTabId, // 表示中のタブID
      dialogStatus: DIALOG_STATUS.disabled.id, // ダイアログ表示用ステータス
      dialogConfirmMoveTabId: null, // 編集画面でタブを遷移する時にタブIDを一時保存しておく
    };

    this.state.spotWorkerInfo.worker_type = window.location.href.includes(
      'NonResidentSpotWorkers'
    )
      ? SPOT_WORKER_TYPE.TEMPORARY.id
      : SPOT_WORKER_TYPE.PERMANENT.id;
  }

  residentType = () => {
    return this.state.spotWorkerInfo.worker_type >= 2
      ? SPOT_WORKER_RESIDENCE_TYPE.NON_RESIDENT.id
      : SPOT_WORKER_RESIDENCE_TYPE.RESIDENT.id;
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - START
   * =====================================================
   */

  /**
   * 現場常駐社員・非常駐入退場者一覧画面に遷移する
   */
  moveBack = () => {
    this.isClosing = true;
    masterSlideLoader.close();
  };

  /**
   * 現場常駐社員・非常駐入退場者詳細ページへ
   */
  moveToConfirm = () => {
    masterSlideLoader.show('SpotWorkerConfirm', {
      state: {
        id: `${this.state.selectedTabId},${
          this.state.spotWorkerInfo.field_spot_worker_id
        }`,
      },
    });
  };

  /**
   * =====================================================
   * 画面遷移周りの処理 - END
   * =====================================================
   */

  /**
   * =====================================================
   * ダイアログ周りの処理 - START
   * =====================================================
   */

  /**
   * 『X』ボタンをクリックした時の処理
   * 登録・編集画面時にはダイアログを表示する
   * 詳細画面時には現場常駐社員・非常駐入退場者一覧へ戻る
   * */
  handlerMoveToBackPage = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.showCancelEditDialog();
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        this.moveBack();
        break;
      default:
        break;
    }
  };

  /**
   * 登録・編集をやめるダイアログを表示する
   * */
  showCancelEditDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.cancelEditDialogEnabled.id;
    this.setState(state);
  };

  /**
   * 編集をやめるダイアログで前のページに戻る時の処理
   */
  handlerBackToPage = () => {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.NEW.ID:
        this.moveBack();
        break;
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.moveToConfirm();
        break;
      default:
        break;
    }
  };

  /**
   * APIのエラーメッセージダイアログを表示する
   * @param {object} response  APIからのレスポンス
   * */
  showErrorMessageDialog = response => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.otherErrorDialogEnabled.id;
    state.informationModal.title = null;
    state.informationModal.message = extractErrorMessage(response);
    state.informationModal.buttonText = messageUtility.getMessage('I-000-017');
    this.setState(state);
  };

  /**
   * ダイアログを閉じる
   * */
  closeDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.title = null;
    state.informationModal.message = null;
    state.informationModal.buttonText = null;
    this.setState(state);
  };

  /**
   * =====================================================
   * ダイアログ周りの処理 - END
   * =====================================================
   */

  /**
   * タブを変更する直前に実行する
   */
  beforeChangeValidTab(selectedTabId) {
    switch (this.props.pageStatus.ID) {
      case WORKER_PAGE_STATUS.EDIT.ID:
        this.setState({
          dialogConfirmMoveTabId: selectedTabId,
          dialogStatus: DIALOG_STATUS.leaveThisPageDialogEnabled.id,
        });
        break;
      case WORKER_PAGE_STATUS.CONFIRM.ID:
        _urlParamManager.setMaster('SpotWorkerConfirm', { state: {} });

        this.setState({
          selectedTabId,
          dialogConfirmMoveTabId: null,
        });
        break;
      default:
        break;
    }
  }

  fetchSpotWorker = async fieldSpotWorkerId => {
    this.setState({ isLoading: true, fetchingInfo: true });
    try {
      const response = await SpotWorkersApi.fetchSingle(
        this.state.fieldId,
        fieldSpotWorkerId
      );
      if (!response.result) {
        this.showErrorMessageDialog(response);
        return;
      }

      const spotWorker = response.data.entities.field_spot_worker_setting;
      SpotWorkersService.processImages(spotWorker);
      if (spotWorker.worker_type == SPOT_WORKER_TYPE.PERMANENT.id) {
        spotWorker.name_sei_kana = spotWorker.name_sei_hiragana;
        spotWorker.name_mei_kana = spotWorker.name_mei_hiragana;
      }
      this.setState({ spotWorkerInfo: spotWorker });
    } catch (error) {
      this.showErrorMessageDialog(error);
    } finally {
      this.setState({ isLoading: false, fetchingInfo: false });
    }
  };

  async componentWillMount() {
    if (this.props.fieldSpotWorkerId) {
      await this.fetchSpotWorker(this.props.fieldSpotWorkerId);
    }
  }

  componentWillUnmount() {
    if (this.isClosing) {
      location.reload();
    }
  }

  render() {
    let contructioSlideViewBodyHeight = 'calc(100vh - 84px)';
    // ios-safariだとツールバー分の高さがある為、考慮する
    // 後々ブラッシュアップが必要
    if (safariOnIosCheck() === true) {
      contructioSlideViewBodyHeight = 'calc(100vh - 115px)';
    }
    const title =
      (this.residentType() === SPOT_WORKER_RESIDENCE_TYPE.RESIDENT.id
        ? '現場常駐社員'
        : '非常駐入退場者') +
      (this.props.pageStatus.ID === WORKER_PAGE_STATUS.NEW.ID
        ? '新規登録'
        : '詳細');

    return (
      <div
        id='slide-view'
        className={`${styles.workerForm} contruction-slide-view show`}
      >
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={<span className='worker__title'>{title}</span>}
            onClose={() => {
              this.handlerMoveToBackPage();
            }}
          />
          <div
            className='contruction-slide-view__body'
            style={{ height: contructioSlideViewBodyHeight }}
          >
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <SpotWorkerTab
                  selectedTabId={this.state.selectedTabId}
                  othersDisabled={
                    this.props.pageStatus.ID === WORKER_PAGE_STATUS.NEW.ID
                  }
                  onTabClick={tabId => {
                    this.beforeChangeValidTab(tabId);
                  }}
                />
              </div>
              <div className='contruction-detail-view__body'>
                {this.state.selectedTabId === WORKER_TAB.WORKER_INFO.ID &&
                  !this.state.fetchingInfo && (
                    <SpotWorkerInfo
                      spotWorkerInfo={this.state.spotWorkerInfo}
                      pageStatus={this.props.pageStatus}
                    />
                  )}
                {this.state.selectedTabId === WORKER_TAB.WORKER_IMAGE.ID && (
                  <SpotWorkerImage
                    spotWorkerInfo={this.state.spotWorkerInfo}
                    pageStatus={this.props.pageStatus}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* 『X』ボタンをクリックした時のダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.cancelEditDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-025')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-050')}
          isNegative
          onConfirm={() => this.handlerBackToPage()}
          onCancel={() => this.closeDialog()}
        />

        {/* 編集画面でタブを遷移する時に表示する確認ダイアログ */}
        <Confirmation
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.leaveThisPageDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-051')}
          confirmButtonText={messageUtility.getMessage('I-000-053')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-052')}
          isNegative
          onConfirm={() => {
            let tabId = '';
            if (this.state.dialogConfirmMoveTabId) {
              tabId = this.state.dialogConfirmMoveTabId;
            }
            masterSlideLoader.show('SpotWorkerConfirm', {
              state: {
                id: `${tabId},${
                  this.state.spotWorkerInfo.field_spot_worker_id
                }`,
              },
            });
          }}
          onCancel={() => this.closeDialog()}
        />
      </div>
    );
  }
}

/**
 * 新規作成フォーム
 */
export class SpotWorkerNew extends React.Component {
  render() {
    return (
      <SpotWorkerForm
        pageStatus={WORKER_PAGE_STATUS.NEW}
        selectedTabId={SPOT_WORKER_TAB.BASIC_INFO.ID}
      />
    );
  }
}

/**
 * 詳細フォーム
 */
export const SpotWorkerConfirm = props => {
  let [selectedTabArg, fieldSpotWorkerId] = props.view.state.id.split(',');
  const selectedTabId = isNullOrUndefinedOrEmptyStr(selectedTabArg)
    ? SPOT_WORKER_TAB.BASIC_INFO.ID
    : parseInt(selectedTabArg);

  return (
    <SpotWorkerForm
      pageStatus={WORKER_PAGE_STATUS.CONFIRM}
      selectedTabId={selectedTabId}
      fieldSpotWorkerId={fieldSpotWorkerId}
    />
  );
};

/**
 * 編集フォーム
 */
export const SpotWorkerEdit = props => {
  let [selectedTabArg, fieldSpotWorkerId] = props.view.state.id.split(',');
  const selectedTabId = isNullOrUndefinedOrEmptyStr(selectedTabArg)
    ? SPOT_WORKER_TAB.BASIC_INFO.ID
    : parseInt(selectedTabArg);

  return (
    <SpotWorkerForm
      pageStatus={WORKER_PAGE_STATUS.EDIT}
      selectedTabId={selectedTabId}
      fieldSpotWorkerId={fieldSpotWorkerId}
    />
  );
};



// WEBPACK FOOTER //
// ./src/pages/SpotWorkerForm.jsx